import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Container } from '@mui/material';
import { useAuthContext } from '../../../../contexts/authContext';

export default function Loading() {
    const { modeTheme } = useAuthContext();

    return (
        <Container maxWidth="lg">
            <CircularProgress
                size={90}
                thickness={3}
                sx={{
                    margin: {
                        lg: '20% 43%',
                        md: '20% 43%',
                        sm: '20% 38%',
                        xs: '20% 33%',
                    },
                    color:
                        modeTheme === 'darkMode'
                            ? 'primary.contrastText'
                            : 'primary.main',
                }}
            />
        </Container>
    );
}
